import { Component, Input } from '@angular/core';
import { JobClient } from '@models/models';

@Component({
	selector: '',
	template: ''
})
export class ClientSubscribeInfoComponent {
	@Input() client: JobClient;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=xqsfzqb50j!./shared/components/base/client/client-subscribe-info/client-subscribe-info.ts